export {Resource} from './lib/resource';